import React from 'react';
import { createRoot } from 'react-dom/client';
import { CustomBestStories } from './components/CustomBestStories';
import { CustomResearchPreviewSlider } from './components/CustomResearchPreviewSlider';
import { convertArticleForHelix } from './utils/research-helpers';
import { GhostArticle } from './types/research';

// Category data structure (matches Flask/Jinja2 output)
interface Category {
    name: string;
    slug: string;
    articles: GhostArticle[];
}

// Mount Best Stories component
document.addEventListener('DOMContentLoaded', () => {
    const bestStoriesContainer = document.getElementById('best-stories-section');

    if (bestStoriesContainer) {
        // Read data from data attributes
        const storiesData = bestStoriesContainer.dataset.stories;

        if (storiesData) {
            try {
                const stories: GhostArticle[] = JSON.parse(storiesData);

                // Handle article navigation - construct URL and navigate
                const handleArticleClick = (slug: string) => {
                    // Find the article to get its category
                    const article = stories.find(a => a.slug === slug);
                    const category = article?.tags?.[0]?.slug || 'editorial';
                    window.location.href = `/research/${category}/${slug}`;
                };

                const root = createRoot(bestStoriesContainer);
                root.render(
                    <CustomBestStories
                        stories={stories.map(story => convertArticleForHelix(story, handleArticleClick))}
                        onArticleClick={handleArticleClick}
                    />
                );
            } catch (error) {
                console.error('Error parsing best stories data:', error);
            }
        }
    }

    // Mount Category Sliders
    const categoryContainers = document.querySelectorAll('[data-research-category]');

    categoryContainers.forEach((container) => {
        const categoryData = (container as HTMLElement).dataset.categoryData;
        const isLast = (container as HTMLElement).dataset.isLast === 'true';

        if (categoryData) {
            try {
                const category: Category = JSON.parse(categoryData);

                // Handle article navigation
                const handleArticleClick = (slug: string) => {
                    window.location.href = `/research/${category.slug}/${slug}`;
                };

                const root = createRoot(container as HTMLElement);
                root.render(
                    <CustomResearchPreviewSlider
                        category={category}
                        onArticleClick={handleArticleClick}
                        isLast={isLast}
                        convertArticleForHelix={(article) => convertArticleForHelix(article, handleArticleClick)}
                    />
                );
            } catch (error) {
                console.error('Error parsing category data:', error);
            }
        }
    });

});
